export default function Loading() {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-teal-50">
      <div className="flex flex-col items-center space-y-6">
        {/* Logo with pulse animation */}
        <div className="relative">
          <div className="absolute inset-0 bg-teal-400 blur-2xl opacity-30 rounded-full animate-pulse"></div>
          <img
            src="/logo.png"
            alt="AUTOCHAIN"
            style={{ animationDuration: "2s", width: 260, height: 57 }}
            className="relative w-64 h-32 md:w-40 md:h-40 object-contain animate-bounce"
          />
        </div>

        {/* Loading text */}
        <div className="text-center space-y-2">
          {/* <h2 className="text-2xl md:text-3xl font-bold text-gray-800">
            AUTOCHAIN
          </h2> */}
          <p className="text-gray-600">智能物流解決方案</p>
        </div>

        {/* Loading spinner */}
        <div className="flex items-center space-x-2">
          <div
            className="w-3 h-3 bg-teal-500 rounded-full animate-bounce"
            style={{ animationDelay: "0s" }}
          ></div>
          <div
            className="w-3 h-3 bg-teal-500 rounded-full animate-bounce"
            style={{ animationDelay: "0.2s" }}
          ></div>
          <div
            className="w-3 h-3 bg-teal-500 rounded-full animate-bounce"
            style={{ animationDelay: "0.4s" }}
          ></div>
        </div>

        {/* Progress bar */}
        <div className="w-64 h-1 bg-gray-200 rounded-full overflow-hidden">
          <div
            className="h-full bg-gradient-to-r from-teal-400 to-blue-500 rounded-full animate-progress"
            style={{
              animation: "progress 2s ease-in-out infinite",
            }}
          ></div>
        </div>
      </div>

      <style>{`
        @keyframes progress {
          0% {
            width: 0%;
            margin-left: 0%;
          }
          50% {
            width: 70%;
            margin-left: 15%;
          }
          100% {
            width: 0%;
            margin-left: 100%;
          }
        }
      `}</style>
    </div>
  );
}
